<style lang="scss" scoped>
.object-map-filter {
  position: relative;
  z-index: 1003;
  top: 0px;
  background: #fff;
  width: 220px;
  border-right: 1px solid #e1e9ed;
  height: calc(100% - 2px);
  opacity: 0;
  pointer-events: none;
  transition: left 0.15s ease-in-out, opacity 0.15s ease-in-out;
  &.is-fixed {
    position: fixed;
    top: 1px;
    left: -220px;
  }
  &.open {
    opacity: 1;
    pointer-events: all;
    left: 0;
  }
}
</style>

<template>
  <div class="object-side object-map-filter p-30" :class="{ open: open, 'is-fixed': fixed }" :style="{ height: header_offset !== 0 ? `calc(var(--vh, 1vh) * 100 - ${header_height}px)` : '100%', top: `${header_offset}px` }">
    <div v-if="open && fixed" class="w-100 d-flex">
      <div @click="$emit('close')" class="ml-auto c-pointer abs-right close-icon-hover">
        <i-close class="i-15"></i-close>
      </div>
    </div>

    <object-filter v-model="value" @input="$emit('input', value)" />
  </div>
</template>

<script>
import ObjectFilter from '@/views/object/partials/filter';

export default {
  name: 'views.object.partials.side',

  components: { ObjectFilter },

  props: {
    fixed: {
      type: Boolean,
      default: true,
    },
    open: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      required: false,
      default: () => {
        return {
          files: {},
          tags: {},
        };
      },
    },
  },

  data: () => ({
    header_height: 0,
    header_offset: 0,
  }),

  mounted() {
    document.querySelectorAll('header').forEach(e => {
      this.header_height += e.offsetHeight;
      if (this.fixed) {
        this.header_offset += e.offsetHeight;
      }
    });
  },
};
</script>
